import React, { Component } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";

import assets from "../../util/assets";
export default class AwaitingModal extends Component {

    render() {
        const awaitStyle = {
            awaitHead: {
                //height: "24px",
                //width: "196px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "24px",
                textAlign: "center",
            },
            awaitBody: {
                //height: "34px",
                //width: "312px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "12px",
                letterSpacing: "0",
                lineHeight: "17px",
                textAlign: "center",
                padding: "0% 9%",
            },
            okButton: {
                //height: "40px",
                //width: "136px",
                borderRadius: "2px",
                backgroundColor: "#1B75BC",
            },
            okButtonText: {
                //height: "19px",
                //width: "20px",
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
        };
        return (
            <Modal isOpen={this.props.showAwaitingModalFlag} toggle={() => this.props.hideAwaitingModal()} centered>
                <ModalHeader className="border-0 justify-content-center">
                    <img
                        src={assets.awaiting_stopwatch}
                        className="rounded img-fluid"
                        alt=""
                        width="50"
                        height="50"
                    />
                </ModalHeader>
                <ModalBody className="justify-content-center">
                    <h4 className="text-center mb-2" style={awaitStyle.awaitHead}>
                        Awaiting Confirmation
              </h4>
                    <p className="text-center" style={awaitStyle.awaitBody}>
                        Your request has been sent to the broadcaster. We will let you
                        know once broadcaster accept your request.
              </p>
                </ModalBody>
                <ModalFooter className="border-0 justify-content-center">
                    <Button
                        color="primary"
                        className="px-5"
                        onClick={() => this.props.hideAwaitingModal()}
                        style={awaitStyle.okButton}
                    >
                        <span style={awaitStyle.okButtonText}>OK</span>
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}